export const TOGGLE_CUSTOM_DOMAIN_TAB = 'toggle-custom-domain-tab'
